import { PageView, useData } from '@kameleoon/react-sdk';
import { useCallback, useRef } from 'react';
import { useKameleoonState } from './useKameleoonState';

export const useUpdatePageView = () => {
    const { addData } = useData();
    const { state } = useKameleoonState();
    const lastTrackedUrlRef = useRef<string | null>(null);

    const update = useCallback(() => {
        if (state.status !== 'initialized' || !state.visitorCode) {
            return;
        }

        const currentUrl = window.location.href;
        if (lastTrackedUrlRef.current !== currentUrl) {
            const pageView = new PageView({
                urlAddress: currentUrl,
                title: document.title,
            });
            addData(state.visitorCode, pageView);
            lastTrackedUrlRef.current = currentUrl;
        }
    }, [addData, state]);

    return update;
};
